import React from "react";

const learningGridArray=[
    {
        order: -1,
        heading: "World class Learning for",
        highlightText: "Anyone, Anywhere",
        description: "Studynotion partners with more than 275+ leading universities and companies to bring flexible affordable, job-relevant online learning to individuals and organizations worldwide",
        BtnText: "Learn more",
        BtnLink: "/",
    },
    {
        order: 1,
        heading: "Curriculum Based on Industry Needs",
        description: "Save time and money, The Belajar curriculum is made to be easier to understand and in with industry needs."
    }
]

const LearningGrid=()=>{
    return ( 
        <div></div>
    )
}

export default LearningGrid;